import { useParams } from 'react-router-dom';
import { CLAIM_STATUSES } from 'all-in-one-shared-api';

import { AddClaimDocuments } from './components/AddClaimDocuments';
import { useClaimPageQuery } from '../../hooks';

/**
 * The flow of Adding document for need action is add documents => submit => claim need action will become submitted
 * From ticket https://generali-hk.atlassian.net/browse/AIOBRB-2063?focusedCommentId=56238
 */
const AddClaimDocumentsPage = (): JSX.Element => {
  const { claimId } = useParams();
  const { sequenceNo, claimStatus } = useClaimPageQuery();

  return (
    <AddClaimDocuments
      claimId={claimId || ''}
      sequenceNo={sequenceNo}
      isShortfall={claimStatus === CLAIM_STATUSES.SHORTFALL}
    />
  );
};

export default AddClaimDocumentsPage;
